import React, { useEffect, useMemo, useState } from "react";
import {
  CLOSES_IN_TONE_CLASS,
  formatClosesIn,
  getFixturePredictionDeadline,
} from "../utils/fixtureDeadline";

/**
 * Live "Closes in Xh" label for a single fixture card.
 */
export default function FixtureCloseCountdown({ fixture, className = "" }) {
  const deadline = useMemo(
    () => getFixturePredictionDeadline(fixture),
    [
      fixture?.prediction_deadline,
      fixture?.postponement_deadline,
      fixture?.match_date,
      fixture?.postponed,
    ]
  );

  const [label, setLabel] = useState(() => formatClosesIn(deadline));

  useEffect(() => {
    const tick = () => setLabel(formatClosesIn(deadline));
    tick();
    const intervalMs =
      deadline && deadline.getTime() - Date.now() < 2 * 60 * 60 * 1000
        ? 30000
        : 60000;
    const id = setInterval(tick, intervalMs);
    return () => clearInterval(id);
  }, [deadline?.getTime()]);

  if (!label.text) return null;

  const showDot = label.tone === "urgent" || label.tone === "soon";

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[12px] leading-5 font-semibold border tabular-nums ${CLOSES_IN_TONE_CLASS[label.tone]} ${className}`}
    >
      {showDot && <span aria-hidden className="w-1.5 h-1.5 rounded-full bg-amber-500" />}
      {label.text}
    </span>
  );
}
